import * as React from "react";
const SvgDown16 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 5L8 11.0005L2 5", stroke: "black", strokeWidth: 2 }));
export default SvgDown16;
